import script from "./BonusDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusDetails.vue?vue&type=script&setup=true&lang=js"

import "./BonusDetails.vue?vue&type=style&index=0&id=471a9202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471a9202"]])

export default __exports__